import { isCacheStale, Nullable } from '@ps/utils';
import { Survey } from '@ps/survey-utils';

import { SURVEY_CHILD_SURVEYS_CACHE_TTL } from './survey-cache.constants';

/**
 * Test if child surveys are cached and not stale.
 * @param parentId - parent survey id
 * @param childSurveys - cached child surveys
 * @param cachedAt - cached child surveys timestamp
 * @returns true if child surveys are cached and not stale.
 */
export const isChildSurveysCacheValid = (
  parentId: number,
  childSurveys: Record<number, Survey[]>,
  cachedAt: Record<number, Nullable<number>>,
): boolean => {
  return (
    parentId in childSurveys &&
    childSurveys[parentId].length > 0 &&
    !isCacheStale(cachedAt[parentId], SURVEY_CHILD_SURVEYS_CACHE_TTL)
  );
};
